var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.97287 2.0542H1.49397C1.23035 2.0542 0.977533 2.15892 0.791127 2.34533C0.604722 2.53173 0.5 2.78455 0.5 3.04817V10.006C0.5 10.2696 0.604722 10.5224 0.791127 10.7088C0.977533 10.8952 1.23035 10.9999 1.49397 10.9999H8.45176C8.71538 10.9999 8.9682 10.8952 9.15461 10.7088C9.34101 10.5224 9.44574 10.2696 9.44574 10.006V6.52707",
    stroke: "#7D89AB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70028 1.30879C8.89799 1.11107 9.16615 1 9.44576 1C9.72537 1 9.99352 1.11107 10.1912 1.30879C10.3889 1.5065 10.5 1.77466 10.5 2.05426C10.5 2.33387 10.3889 2.60203 10.1912 2.79974L5.46987 7.5211L3.48193 8.01809L3.97892 6.03015L8.70028 1.30879Z",
    stroke: "#7D89AB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.80d4667b9b2f69f3ed40093f201bc573.svg";
export { ForwardRef as ReactComponent };